/**
 * Compact AI summary of the pre×post scatter ("Spreiding per deelnemer"):
 * counts per direction and the average growth per participant. Dutch keys —
 * the summary is embedded verbatim in Decca's Dutch analysis prompt.
 * Pure function — no Firebase imports.
 */

/**
 * @param {Array<{x: number, y: number}>} points - buildPrePostScatter output (x = first, y = last measurement)
 * @param {number} [totalRespondents] - All respondents of the indicator, including single-moment ones
 * @returns {{deelnemersMetMeerdereMetingen: number, gegroeid: number, gelijkGebleven: number, gedaald: number, gemiddeldeGroei: number, totaalRespondenten: number|null}|null}
 */
const summarizeScatterForAI = (points, totalRespondents) => {
    const list = Array.isArray(points) ? points : []
    if (!list.length) return null

    const gegroeid = list.filter((p) => p.y > p.x).length
    const gedaald = list.filter((p) => p.y < p.x).length
    const totalGrowth = list.reduce((sum, p) => sum + (p.y - p.x), 0)

    return {
        deelnemersMetMeerdereMetingen: list.length,
        gegroeid,
        gelijkGebleven: list.length - gegroeid - gedaald,
        gedaald,
        gemiddeldeGroei: Math.round((totalGrowth / list.length) * 100) / 100,
        totaalRespondenten: totalRespondents || null,
    }
}

export default summarizeScatterForAI
